/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   marketing utils helpers
 */

import { MESSAGE, MULTI } from '../constants/leadType'

const getLeadType = ({ isMulti }) => {
  if (isMulti) {
    return MULTI
  }

  return MESSAGE
}

export default getLeadType
